import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import Header from '../layout/header';
import Sidebar from '../layout/sidebar';
import MainContainer from '../layout/main-container';
import Views from './views';
import { JobsLock, JobsProvider, MqttClientProvider, useJobsState, useSubscribeJobsState } from './devices';
import { AuthRequired, useAuthUser } from './auth';
import AfterSalesDatabase from '../model/aftersales/AfterSalesDatabase';
import RegistrationDatabase from '../model/registration/RegistrationDatabase';

export function MainViewWithMqttProvider() {

  const user = useAuthUser();
  const name = useMemo(() => user.sub, []);

  return (
    <AfterSalesDatabase suffix={name}>
      <RegistrationDatabase suffix={name}>
        <Box sx={{ display: 'flex', flexGrow: 1 }}>
          <Header />
          <Sidebar />
          <MainContainer>
            <Views />
          </MainContainer>
        </Box>
      </RegistrationDatabase>
    </AfterSalesDatabase>
  )
}

export default function MainView() {
  return (
    <AuthRequired>
        <MqttClientProvider>
          <MainViewWithMqttProvider />
        </MqttClientProvider>
    </AuthRequired>
  );
}
